import React from "react"
import { Provider } from "react-redux"
import createStore from "./configureStore"

const store = createStore();

export default ({ element }) => <Provider store={store}>{element}</Provider>